var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBa2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 361.137,
    height: 156.069,
    viewBox: "0 0 361.137 156.069",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4853.166 -1196.081)",
    fill: "none",
    strokeMiterlimit: 10
  }, /*#__PURE__*/React.createElement("path", {
    stroke: "#6e7e9d",
    d: "M4887.425 1212.137v55.677m39.578-55.677v55.677m39.579-55.677v55.677m-79.157 15.557v52.723m219.744-123.957v55.677m0 15.557v52.723m39.578-123.957v55.677m0 15.557v52.723m39.579-123.957v55.677m0 15.557v52.723m-259.323-52.723v52.723m39.579-52.723v52.723m27.976-83.12v45.236l39.176 22.618 39.176-22.618v-45.236l-39.176-22.618zm39.176 67.855v-45.236"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4994.558 1252.974l39.176 22.618 39.176-22.618",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5011.093 1307.757V1262.3l39.168-22.4",
    stroke: "#6e7e9d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4974.36 1204.359h16.056a10 10 0 017.071 2.929l27.746 27.746m-50.873 108.838h16.056a10 10 0 007.071-2.929l25.623-25.624m76.281-110.96h-22.339a10 10 0 00-7.071 2.929l-27.945 27.945m57.355 108.639h-22.339a10 10 0 01-7.071-2.929l-26.164-26.164m150.287-39.186h20.198m-59.777 0h24.022m-63.6 0h24.022m-66.059 0h26.481",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5099.391 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5138.969 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5178.547 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4974.359 1275.593h20.198m-59.776 0h24.022m-63.6 0h24.022m-66.059 0h26.481"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4879.646 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4919.225 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4958.803 1267.814)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4934.781 1204.359h24.022m-63.6 0h24.022m-66.059 0h26.481"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4879.646 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4919.225 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4958.803 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M4934.781 1343.871h24.022m-63.6 0h24.022m-66.059 0h26.481"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4879.646 1336.093)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4919.225 1336.093)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(4958.803 1336.093)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M5194.104 1204.359h20.198m-59.777 0h24.022m-63.6 0h24.022"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5099.391 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5138.969 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5178.547 1196.581)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#0c9",
    d: "M5194.104 1343.871h20.198m-59.777 0h24.022m-63.6 0h24.022"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5099.391 1336.093)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5138.969 1336.093)",
    stroke: "#0c9"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 7.778,
    cy: 7.778,
    r: 7.778,
    transform: "translate(5178.547 1336.093)",
    stroke: "#0c9"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBa2);
export default __webpack_public_path__ + "static/media/ba2.adb252ed8e14d8436fa4e1e7bb0bbd68.svg";
export { ForwardRef as ReactComponent };